import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAllPoojaris, getPendingPoojaris, getAllUsers } from '../../services/adminService';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const AdminDashboard = () => {
    const [stats, setStats] = useState({
        totalPoojaris: 0,
        pendingPoojaris: 0,
        totalUsers: 0
    });
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/admin-login');
            return;
        }
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const [poojaris, pending, users] =
                await Promise.all([
                    getAllPoojaris(),
                    getPendingPoojaris(),
                    getAllUsers()
                ]);
            setStats({
                totalPoojaris: poojaris.length,
                pendingPoojaris: pending.length,
                totalUsers: users.length
            });
        } catch (error) {
            toast.error('Error fetching stats');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (
        <div className="text-center py-5">
            <div className="spinner-border"
                style={{ color: '#8B4513' }}>
            </div>
        </div>
    );

    return (
        <div className="container py-4">
            <h2 className="fw-bold mb-4">
                🔐 Admin Dashboard
            </h2>

            {/* Stats Cards */}
            <div className="row g-3 mb-4">
                <div className="col-md-4">
                    <div className="card text-white text-center p-4"
                        style={{ backgroundColor: '#8B4513' }}>
                        <div className="display-5">🙏</div>
                        <h2 className="fw-bold">
                            {stats.totalPoojaris}
                        </h2>
                        <p className="mb-0">Total Poojaris</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card text-white text-center p-4 bg-warning">
                        <div className="display-5">⏳</div>
                        <h2 className="fw-bold">
                            {stats.pendingPoojaris}
                        </h2>
                        <p className="mb-0">Pending Approvals</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card text-white text-center p-4 bg-success">
                        <div className="display-5">👤</div>
                        <h2 className="fw-bold">
                            {stats.totalUsers}
                        </h2>
                        <p className="mb-0">Total Users</p>
                    </div>
                </div>
            </div>

            {/* Quick Actions */}
            <div className="row g-3">
                <div className="col-md-6">
                    <div className="card shadow-sm h-100">
                        <div className="card-header fw-bold"
                            style={{ backgroundColor: '#FFF8F0' }}>
                            Poojari Management
                        </div>
                        <div className="card-body">
                            <Link to="/admin/poojaris"
                                className="btn w-100 text-white mb-2"
                                style={{ backgroundColor: '#8B4513' }}>
                                🙏 Manage Poojaris
                            </Link>
                            <Link to="/admin/poojaris"
                                className="btn w-100 btn-warning">
                                ⏳ Pending Approvals
                                {stats.pendingPoojaris > 0 && (
                                    <span className="badge bg-danger ms-2">
                                        {stats.pendingPoojaris}
                                    </span>
                                )}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card shadow-sm h-100">
                        <div className="card-header fw-bold"
                            style={{ backgroundColor: '#FFF8F0' }}>
                            User Management
                        </div>
                        <div className="card-body">
                            <Link to="/admin/users"
                                className="btn w-100 text-white mb-2"
                                style={{ backgroundColor: '#8B4513' }}>
                                👤 Manage Users
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;